"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPreviewerUpdateSideMenuAction = exports.buildPreviewerUpdateRouteStackAction = void 0;
const previewerStateConstants_1 = __importDefault(require("./previewerStateConstants"));
const buildPreviewerUpdateRouteStackAction = (payload) => ({
    type: previewerStateConstants_1.default.UPDATE_ROUTE_STACK,
    payload,
});
exports.buildPreviewerUpdateRouteStackAction = buildPreviewerUpdateRouteStackAction;
const buildPreviewerUpdateSideMenuAction = (payload) => ({
    type: previewerStateConstants_1.default.UPDATE_SIDE_MENU,
    payload,
});
exports.buildPreviewerUpdateSideMenuAction = buildPreviewerUpdateSideMenuAction;
